import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { ChartsModule } from 'ng2-charts/ng2-charts';
import { MyDateRangePickerModule } from 'mydaterangepicker';

import { TranslateModule } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';

import { StatisticComponent } from './statistic.component';
import { StatisticService } from './statistic.service';

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MyDateRangePickerModule,
    TranslateModule,
    ChartsModule
  ],
  declarations: [
    StatisticComponent
  ],
  exports: [
    StatisticComponent
  ],
  providers: [
    StatisticService,
    TranslateService
  ]
})
export class StatisticModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/statistics/statistic.module.ts